/* Google Analytics 4 — зарежда се само след „Приемам“ в банера за бисквитки.
   Преди съгласие към Google не отива нищо. Отказът се помни и банерът не се
   показва отново, докато човекът не натисне „Бисквитки“ във футъра. */

export const GA_ID = 'G-LRYRS3WE24';

// Нов ключ: старото „Разбрах“ (cookie_consent) беше за бисквитки само за
// входа и не е съгласие за статистика.
const KEY = 'sa_consent';
export const OPEN_EVENT = 'sa-consent-open';

export const readConsent = () => {
  try { return localStorage.getItem(KEY); } catch { return null; }
};

let loaded = false;

export function loadAnalytics() {
  if (loaded || !GA_ID || typeof window === 'undefined') return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID);
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}

export function saveConsent(value) {
  try { localStorage.setItem(KEY, value); } catch { /* само за тази сесия */ }
  if (value === 'all') loadAnalytics();
}

/** Запитване за поръчка: method е 'chat', 'viber' или 'phone'. */
export function trackLead(method) {
  if (loaded) window.gtag('event', 'generate_lead', { method });
}
